<template>
  <div class="set-password">
    <div class="login-header">
      <div class="is-size-3">
        {{ $t('authenticator.set_password') }}
      </div>
      <span class="is-size-5">{{ $t('authenticator.set_password_instruction') }}</span>
    </div>
    <div>
      <div class="field">
        <label class="label is-medium">{{ $t('authenticator.confirm_code') }} *</label>
        <div class="control">
          <input
            v-model="user.code"
            class="input is-large"
            type="text"
            :placeholder="$t('authenticator.code_ph')"
          >
        </div>
      </div>
      <div class="field">
        <label class="label is-medium">{{ $t('authenticator.new_password') }} *</label>
        <div class="control">
          <input
            v-model="user.password"
            class="input is-large"
            type="password"
            :placeholder="$t('authenticator.new_password_ph')"
          >
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button
          class="button is-primary is-large is-broad is-uppercase"
          :class="{'is-loading': isLoading}"
          @click="verify"
        >
          {{ $t('common.confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SIGNED_OUT, REQUIRE_NEW_PASSWORD } from './auth-actions'
export default {

  name: 'ResetPassword',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      SIGNED_OUT,
      user: {
        code: '',
        password: ''
      },
      isLoading: false
    }
  },
  // Assign constants to the this.$options object
  created () {
    this.$options.SIGNED_OUT = SIGNED_OUT
    this.$options.REQUIRE_NEW_PASSWORD = REQUIRE_NEW_PASSWORD
  },
  mounted () {
    this.resetPassword(this.username)
  },
  methods: {
    async resetPassword () {
      this.isLoading = true
      try {
        await this.$auth.forgotPassword(this.username)
      } catch (err) {
        this.$emit('changeAuthState', this.$options.REQUIRE_NEW_PASSWORD)
      } finally {
        this.isLoading = false
      }
    },
    async verify () {
      this.isLoading = true
      const { code, password } = this.user
      try {
        await this.$auth.forgotPasswordSubmit(this.username, code, password)
        this.$emit('changeAuthState', this.$options.SIGNED_OUT)
      } catch (err) {
        this.$emit('displayError', err.message)
      }
      this.isLoading = false
    }
  }
}
</script>
